import React, { useContext, useEffect, useState } from "react";
import "../../styles/pages/Editor.scss";
import {
  sendExport,
  getExport,
  browseImages,
  imageConversion,
  imageConversionBaseURL,
} from "../../services/apis";
import exportHTML from "../Editor/HtmlExport";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import ValueContext from "../../ContextAPi/appContext";
import { toast } from "react-toastify";
import FileSaver from "file-saver";
import { downLoad } from "../Editor/DownloadHTML";
import { downLoadPdf } from "../Editor/PDFDownload";
import RVCV from "../Editor/RVCV";
import { useTranslation } from "react-i18next";

export default function EditorHeader({
  type,
  setType,
  setLoading,
  canvasDimension,
  canvasDom,
  animationObj,
  fontLink,
  checkExportType,
  setCheckExportType,
  rvcvTypes,
  setRvcvTypes,
  layerCompData,
  setHtmlContent,
  animationObjecStringified,
  anmObj,
  backupFallback
}) {
  const appData = useContext(ValueContext);
  const t = useTranslation();
  useEffect(() => {
    exportType(type);
  }, []);

  function dataURItoBlob(dataURI) {
    var binary = atob(dataURI.split(",")[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
  }
  const exportType = async (type) => {
    //const formData = new FormData();
    let finalDOMObj = downLoad({
      exportData: checkExportType.HTML ? true : false,
      layerCompData: canvasDom,
      assetId: appData.assetInfo.assetId,
      canvasDimension: canvasDimension,
      bgColorCanvas: canvasDimension.bgColorCanvas,
      animationObject: anmObj,
      flag:
        checkExportType.PNG === true || checkExportType.JPG === true
          ? true
          : false,
    });
    let DOMObj = formDOMObj(finalDOMObj);
    let htmlContentObj = DOMObj;
    Object.keys(checkExportType).forEach(async (key) => {
      if (key === "HTML" && checkExportType[key] === true) {
        finalDOMObj = downLoad({
          exportData: true,
          layerCompData: canvasDom,
          assetId: appData.assetInfo.assetId,
          canvasDimension: canvasDimension,
          bgColorCanvas: canvasDimension.bgColorCanvas,
          animationObject: animationObj,
          flag:
            checkExportType.PNG === true || checkExportType.JPG === true
              ? true
              : false,
        });

        let htmlDomObj = formDOMObj(finalDOMObj);
        htmlDomObj.assetId = appData.assetInfo.assetId
        htmlDownload(htmlDomObj);
      } else if (key === "JPG" && checkExportType[key] === true) {
        imageConversion(
          "png",
          { html: DOMObj.html },
          (response, err, errorCode) => {
            if (err) {
              toast.error(
                <div className="notificationText">
                  Failed to download the JPEG file
                </div>,
              );
              setLoading(false);
            } else {
              if (response?.image) {
                let rep = dataURItoBlob(response.image);
                var file = new File(
                  [rep],
                  `${appData.assetInfo.assetName}.jpg`,
                  {
                    type: "image/jpg",
                  },
                );
                const formDatatype = new FormData();
                formDatatype.append("fileName", file);
                pngJpegPdfDownload(key, formDatatype);
                toast.success(
                  <div className="notificationText">
                    Successfully downloaded the JPEG file
                  </div>,
                );
              } else {
                setLoading(false);
                toast.error(
                  <div className="notificationText">
                    Failed to download the JPEG file
                  </div>,
                );
                return;
              }
            }
          },
        );
      } else if (key === "PNG" && checkExportType[key] === true) {
        imageConversion(
          "png",
          { html: DOMObj.html },
          (response, err, errorCode) => {
            if (err) {
              toast.error(
                <div className="notificationText">
                  Failed to download the PNG file
                </div>,
              );
              setLoading(false);
            } else {
              if (response?.image) {
                let rep = dataURItoBlob(response.image);
                var file = new File(
                  [rep],
                  `${appData.assetInfo.assetName}.png`,
                  {
                    type: "image/png",
                  },
                );
                const formDatatype = new FormData();
                formDatatype.append("fileName", file);
                pngJpegPdfDownload(key, formDatatype);
                toast.success(
                  <div className="notificationText">
                    Successfully downloaded the PNG file
                  </div>,
                );
              } else {
                setLoading(false);
                toast.error(
                  <div className="notificationText">
                    Failed to download the PNG file
                  </div>,
                );
                return;
              }
            }
          },
        );
      } else if (key === "PDF" && checkExportType[key] === true) {
        let finalPdf = downLoadPdf(
          canvasDom,
          appData.assetInfo.assetId,
          canvasDimension,
          canvasDimension.bgColorCanvas,
          {},
        );

        const formDatatype = new FormData();
        DOMObj = formDOMObj(finalPdf);
        imageConversionBaseURL(
          "pdf",
          { html: DOMObj.html },
          (response, err, errorCode) => {
            if (err) {
              toast.error(
                <div className="notificationText">
                  Failed to download the PDF file
                </div>,
              );
              setLoading(false);
            } else {
              if (response?.status === 200) {
                var blob = new Blob([response?.data], {
                  type: "application/pdf",
                });
                var file = new File(
                  [blob],
                  `${appData.assetInfo.assetName}.pdf`,
                  {
                    type: "application/pdf",
                  },
                );
                formDatatype.append("fileName", file);
                pngJpegPdfDownload("pdf", formDatatype);
                toast.success(
                  <div className="notificationText">
                    Successfully downloaded the PDF file
                  </div>,
                );
              } else {
                setLoading(false);
                toast.error(
                  <div className="notificationText">
                    Failed to download the PDF file
                  </div>,
                );
                return;
              }
            }
          },
        );
      } else if (key === "RVCVFILE" && checkExportType[key] === true) {
        setLoading(true);

        finalDOMObj = downLoad({
          layerCompData: canvasDom,
          assetId: appData.assetInfo.assetId,
          canvasDimension: canvasDimension,
          bgColorCanvas: canvasDimension.bgColorCanvas,
          animationObject: animationObj,
          flag: true,
        });

        let DOMObj = formDOMObj(finalDOMObj, "rvcv");
        let obj = {
          page: DOMObj.html,
          rvcv:
            rvcvTypes.value2X === true ? 2 : rvcvTypes.value3X === true ? 3 : 1,
          name: appData.assetInfo.assetName,
          emailID: localStorage.getItem("userEmail"),
          currentUserName: localStorage.getItem("currentUserName"),
        };

        imageConversionBaseURL("RVCV", obj, (response, err, errorCode) => {
          if (err) {
            setLoading(false);
            toast.error(
              <div className="notificationText">
                Failed to download the RV/CV file
              </div>,
            );
          } else {
            if (response.status === 200) {
              setLoading(false);
              toast.success(
                <div className="notificationText">
                  Please click on the link sent to you via email to download the
                  RV/CV images.
                </div>,
              );
            } else {
              const errCoponent = ErrComponentToRender(response.status);
              toast.error(errCoponent);
              setLoading(false);

              return;
            }
          }
        });
      } else if (key === "Preview" && checkExportType[key] === true) {
        // const htmlObj=JSON.stringify(htmlContent.html)
        // setHtmlContent(htmlObj)
        if (htmlContentObj && htmlContentObj.html) {
          const htmlObj = JSON.stringify(htmlContentObj.html);
          setHtmlContent((prevState) => ({
            ...prevState,
            html: htmlObj,
          }));
        }
      }
    });

    setType(false);
    setCheckExportType({
      ...checkExportType,
      PDF: false,
      HTML: false,
      PNG: false,
      JPG: false,
      RVCVFILE: false,
    });
    setRvcvTypes({
      ...rvcvTypes,
      value2X: false,
      value3X: false,
    });
  };
  const pngJpegPdfDownload = (type, formData) => {
    browseImages(formData, (response, err, errorCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errorCode);
        setLoading(false);
      } else {
        if (response.data.discription) {
          FileSaver.saveAs(
            response.data.discription,
            `${appData.assetInfo.assetName}.${type}`,
          );
          setLoading(false);
        }
      }
    });
  };
  function htmlDownload(DOMObj) {
    const exportPayload = { ...DOMObj };
    sendExport(exportPayload, (response, err, errorCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errorCode);

        toast.error(errCoponent);
      } else {
        getExport(
          randomNumber,
          appData.assetInfo.assetName,
          (response, err, errorCode) => {
            if (err) {
              const errCoponent = ErrComponentToRender(errorCode);
              toast.error(
                <div className="notificationText">
                  Failed to download the HTML package
                </div>,
              );
            } else {
              const downloadUrl = window.URL.createObjectURL(
                new Blob([response.data]),
              );

              const link = document.createElement("a");

              link.href = downloadUrl;

              link.setAttribute(
                "download",
                appData.assetInfo.assetName + ".zip",
              ); //any other extension

              document.body.appendChild(link);

              link.click();

              link.remove();
              toast.success(
                <div className="notificationText">
                  Successfully downloaded the HTML package
                </div>,
              );
            }
          },
        );
      }
    });
    setLoading(false);
  }

  let randomNumber = new Date().getTime();
  function formDOMObj(finalDOMObj, rvcv, exportOptions = {}) {
    let animationFinalObjToString = JSON.stringify(animationObj);
    let completeObj = JSON.stringify(finalDOMObj.trackHeight);
    let layerLink = "";
    let typeDiff = `
  <div
    id="canvas-page"
    data-global="${canvasDimension.globalLink}"
    data-link="${canvasDimension.checkGloballink}"
  >
    ${finalDOMObj.DomObj}
  </div>
`;

    let expandClose =
      canvasDimension.width < 310
        ? `function expandBanner(id) {

           var foundEle = completeObj.find(function (element) {
                           return element.id ===id ;
                         });

        let expanHeight = document.getElementById("expand"+id).clientHeight||0;
        let heightTracK = ${canvasDimension.height}-expanHeight-foundEle.arrowHeight*2-4;

        gsap.to('#'+'expand'+id, 0, {display:'none' });
        gsap.to('#'+'close'+id, 0, {display:'block' });
        gsap.to('#'+id, 0.5, {top:0,height: ${canvasDimension.height}});
        gsap.to('#'+id+'ISIInfo', 0.5, {height: (${canvasDimension.height}-expanHeight)});
        gsap.to('#'+id+'viewport', 0.5, {top:0,height: (${canvasDimension.height}-expanHeight) });
       
        gsap.to('#scrollbar'+id, 0.5, {height:heightTracK});
        gsap.to('#'+id+'track', 0.5, {height:heightTracK, onUpdate:function test (){updateTiny(id,heightTracK);}});
    
    }
    function  closeBanner(id){
        var foundEle = completeObj.find(function (element) {
          return element.id ===id ;
        });

        gsap.to('#'+'expand'+id, 0, {display:'block'});
        gsap.to('#'+'close'+id, 0, {display:'none'});
        gsap.to('#'+id, 0.5, {top:foundEle.compTop,height: foundEle.compHeight});
        gsap.to('#'+id+'ISIInfo', 0.5, {height: foundEle.compHeight + (foundEle.arrowHeight === 0 ? 0 : 2)-foundEle.expandHeight});
        gsap.to('#'+id+'viewport', 0.5, {top:0,height: foundEle.compHeight });
      
        gsap.to('#scrollbar'+id, 0.5, {height:
          foundEle.compHeight -
          foundEle.arrowHeight * 2 -
          (foundEle.arrowHeight == 0 ? 0 : 2)-foundEle.expandHeight
        });
   
      gsap.to('#'+id+'track', 0.5, {height:foundEle.trackHeight, onComplete:function test (){updateTiny(id,foundEle.trackHeight);}});

      }
      
      function updateTiny(id, heightTracK, heightThumb = null) {
        let tinyscrollbar = $("#" + id + "ISIInfo").data("plugin_tinyscrollbar");
        tinyscrollbar.options.trackSize = heightTracK;
        if(heightThumb){
          tinyscrollbar.options.thumbSize = heightThumb
        }
        tinyscrollbar.update(0);
      };
      `
        : `function expandBanner(id) {

        var foundEle = completeObj.find(function (element) {
                        return element.id ===id ;
                      });

     let expanHeight = document.getElementById("expand"+id).clientHeight||0;
     let heightTracK =( ${canvasDimension.height}-expanHeight-foundEle.arrowHeight*2-4);

     gsap.to('#'+'expand'+id, 0, {display:'none' });
     gsap.to('#'+'close'+id, 0, {display:'block' });
     gsap.to('#'+id, 0.5, {left:0, top:0,height: ${canvasDimension.height} , width: ${canvasDimension.width}});
     gsap.to('#'+id+'ISIInfo', 0.5, {left:0, height: (${canvasDimension.height}-expanHeight), width: ${canvasDimension.width}});
    
     gsap.to('#scrollbar'+id, 0.5, {height:heightTracK});
     gsap.to("#"+id+"track",0.5,{height:heightTracK,onComplete: function test(){updateTiny(id,heightTracK);}});
 
 }

 function  closeBanner(id){
     var foundEle = completeObj.find(function (element) {
       return element.id ===id ;
     });
   
     gsap.to('#'+'expand'+id, 0, {display:'block'});
     gsap.to('#'+'close'+id, 0, {display:'none'});
     gsap.to('#'+id, 0.5, {top:foundEle.compTop, left:foundEle.compLeft,height: foundEle.compHeight, width:foundEle.compWidth});
     gsap.to('#'+id+'ISIInfo', 0.5, {height: foundEle.compHeight + (foundEle.arrowHeight === 0 ? 0 : 2)-foundEle.expandHeight, width: foundEle.compWidth}  );
     gsap.to('#'+id+'viewport', 0.5, {top:0,height: foundEle.compHeight });
   
     gsap.to('#scrollbar'+id, 0.5, {height:
       foundEle.compHeight -
       foundEle.arrowHeight * 2 -
       (foundEle.arrowHeight == 0 ? 0 : 2)-foundEle.expandHeight
     });
   
   gsap.to('#'+id+'track', 0.5, {height:foundEle.trackHeight, onUpdate:function test (){updateTiny(id,foundEle.trackHeight);}});

   }
   
    function updateTiny(id, heightTracK, heightThumb = null) {
      let tinyscrollbar = $("#" + id + "ISIInfo").data("plugin_tinyscrollbar");
      tinyscrollbar.options.trackSize = heightTracK;
      if(heightThumb){
        tinyscrollbar.options.thumbSize = heightThumb
      }
      tinyscrollbar.update(0);
    };
   `;

    layerLink = fontLink;
    const savedCustomFontList = appData?.savedCustomFontList || []
    
    let DOMObj = {
      html:
        rvcv === "rvcv"
          ? RVCV({
              canvasDimension,
              finalDOMObj,
              animationFinalObjToString,
              layerLink,
              completeObj,
              typeDiff,
              layerCompData,
              savedCustomFontList,
              backupFallback,
            })
          : exportHTML({
              savedCustomFontList,
              canvasDimension,
              finalDOMObj,
              animationFinalObjToString,
              layerLink,
              completeObj,
              typeDiff,
              expandClose,
              animationObjecStringified,
              backupFallback,
              bannerName: appData.assetInfo.assetName?.trim(),
            }),

      cssObj: {
        fileName: "Styles",
        content: "",
      },
      js: "",
      atomId: finalDOMObj.atomId,
      atomUrl: finalDOMObj.atomUrl,
      img: finalDOMObj.img,
      backupImage: backupFallback?.s3Url
        ? {
            url: backupFallback.s3Url,
          }
        : undefined,
      id: randomNumber,
      fileName: appData.assetInfo.assetName.trim(), //put assetname here
    };
    return DOMObj;
  }
  return <></>;
}
